import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { ChevronComponent } from '@shared/chevron/chevron.component';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'companyid-contact-and-plans-buttons',
    imports: [ChevronComponent, RouterLink],
    templateUrl: './contact-and-plans-buttons.component.html',
    styleUrl: './contact-and-plans-buttons.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactAndPlansButtonsComponent {
    @HostBinding('class')
    public readonly hostClassname = 'flex w-full gap-x-30px mt-25px mob:flex-col mob:gap-15px';
}
